export const buildFullUrl = (path) => {
  const base = process.env.VUE_APP_BASE_URL || window.location.origin;
  return `${base}${path}`;
};
